import { ImmutableMap } from "@suse-o11y/immutable-map";

import type { LayoutPane } from "./LayoutPane";
import { FILTER_PANE_NAME, type PaneName } from "./PaneNames";

/**
 * TODO STAC-18702
 *
 * Historically, StackState had a few panes located around the main content.
 * The panes names were based on the cardinal points, like north, east, south and west.
 * Eventually some of the panes have been relocated or completely removed, but their names
 * remained unchanged due to lack of time to make such "stylistic" changes.
 *
 * With that in mind, you should know that the WestPanes (only one in fact) are located in
 * the filters dropdown in the PerspectiveSwitcher.
 */
export const WestPanes: ImmutableMap<PaneName, LayoutPane> = ImmutableMap.fromList<PaneName, LayoutPane>(
	(pane) => pane.name,
	[
		{
			name: FILTER_PANE_NAME,
		},
	],
);
